import { useCallback, useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export default function BeforeAfterSlider({ before, after, beforeLabel = "Before", afterLabel = "After", className = "" }) {
    const ref = useRef(null);
    const [pos, setPos] = useState(56);
    const dragging = useRef(false);

    const setFromClientX = useCallback((clientX) => {
        const rect = ref.current?.getBoundingClientRect();
        if (!rect) return;
        const pct = ((clientX - rect.left) / rect.width) * 100;
        setPos(Math.min(94, Math.max(6, pct)));
    }, []);

    const onPointerDown = (e) => {
        dragging.current = true;
        ref.current?.setPointerCapture?.(e.pointerId);
        setFromClientX(e.clientX);
    };
    const onPointerMove = (e) => { if (dragging.current) setFromClientX(e.clientX); };
    const stop = () => { dragging.current = false; };

    return (
        <div
            ref={ref}
            data-testid="before-after-slider"
            onPointerDown={onPointerDown}
            onPointerMove={onPointerMove}
            onPointerUp={stop}
            onPointerLeave={stop}
            className={`relative select-none touch-none overflow-hidden rounded-2xl border border-white/15 cursor-ew-resize ${className}`}
        >
            <img src={after} alt={afterLabel} draggable={false} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
                <img src={before} alt={beforeLabel} draggable={false} className="w-full h-full object-cover" />
            </div>
            <span className="absolute top-3 start-3 px-2.5 py-1 rounded-full bg-black/55 backdrop-blur text-white text-[10.5px] font-mono-tr tracking-[0.18em] uppercase pointer-events-none" data-testid="ba-label-before">{beforeLabel}</span>
            <span className="absolute top-3 end-3 px-2.5 py-1 rounded-full bg-cyan-400/90 text-[#0B1120] text-[10.5px] font-mono-tr tracking-[0.18em] uppercase font-semibold pointer-events-none" data-testid="ba-label-after">{afterLabel}</span>
            <div className="absolute inset-y-0 pointer-events-none" style={{ left: `${pos}%` }}>
                <div className="absolute inset-y-0 -translate-x-1/2 w-[2px] bg-white/90 shadow-[0_0_12px_rgba(0,0,0,0.5)]" />
                <div className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 h-10 w-10 rounded-full bg-white text-[#0B1120] flex items-center justify-center shadow-xl ring-4 ring-white/25" data-testid="ba-handle">
                    <span className="absolute inline-flex h-full w-full rounded-full bg-white/30 animate-ping" aria-hidden />
                    <ChevronsLeftRight size={17} className="relative" />
                </div>
            </div>
        </div>
    );
}
